import React, { useEffect, useRef } from "react";
import { TwitterPicker } from 'react-color';
import { StyleTag } from "seed/helpers";

const ColorPicker = ({
  id,
  className,
  colors = [
    "#FF5252", "#FF4081", "#7B1FA2", "#512DA8", "#536DFE", "#2065a5", "#3075BA", "#1976D2", "#03A9F4", "#0097A7", "#00796B", "#4CAF50", "#AFB42B",
    "#F57C00", "#FFA000", "#FF5722", "#5D4037", "#9E9E9E", "#455A64", "#212121", "default", "transparent"
  ],
  label,
  name,
  value,
  values,
  defaultColor,
  side = "right",
  setFieldValue = () => { },
  onChange = () => { }
}) => {

  const inputRef = useRef(null);

  let showName = name ? "show_" + name : id;
  let fieldValue = name ? values[name] : value;
  let oppositeSide = side === "left" ? "right" : "left";

  useEffect(() => {
    
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target))
        setFieldValue(showName, false);
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);

  }, [setFieldValue, showName]);

  return <div className="" ref={inputRef}>
    <StyleTag content={`
      .twitter-picker input[id^=rc-editable-input] {
        display: none;
      }
      .twitter-picker div[style*="rgb(240, 240, 240)"] {
        display: none !important;
      }
    `} />
    {
      label && 
        <div className="mb-1 mr-2">
          {label}
        </div>
    }
    <div className={`m-0 p-0 ${className}`} style={{ position: "relative" }}>
      <div className={`color-picker-preview`}  onClick={() => setFieldValue(showName, !values[showName])}>
        <div className="color" style={{ backgroundColor: fieldValue ?? defaultColor }}></div>
      </div>
      <div style={{ position: "absolute", [oppositeSide]: "110%", top: "-14px", zIndex: 1000 }}>
        {
          values[showName] &&
            <TwitterPicker
              color={fieldValue ?? defaultColor}
              width="240px"
              triangle="hide"
              onChange={(color) => {
                if (name) setFieldValue(name, color.hex);
                setFieldValue(showName, false);
                onChange(color.hex);
              }}
              colors={colors}
            />
        }
      </div>
    </div>
  </div>
}

export default ColorPicker;